import debounce from 'lodash/debounce';

/**
 * Get the height of the { position: fixed/sticky } masthead so that we can
 * account the height to avoid underlapping.
 */
const getMastheadHeight = () => {
  const masthead = document.querySelector('.js-masthead');
  if (!masthead) {
    return 0;
  }
  return masthead.offsetHeight;
};

/**
 * Get the offset between the top of the window and the "fixed" position of the
 * sidebar when scrolled.
 */
const getSidebarOffset = () => {
  const offset = 30;
  return offset + getMastheadHeight();
};

/**
 * Get the transform value based off scroll position.
 */
const getSidebarTransfrom = (sidebar, sidebarContainer) => {
  const { scrollY } = window;
  const sidebarOffset = getSidebarOffset();
  const sidebarPosition =
    sidebarContainer.getBoundingClientRect().top + scrollY;
  const translateMin = Math.max(scrollY + sidebarOffset - sidebarPosition, 0);
  const translateMax = sidebarContainer.offsetHeight - sidebar.offsetHeight;
  const translate = Math.min(translateMin, translateMax);
  return `translateY(${translate}px)`;
};

/**
 * Handle the window scroll event.
 */
const handleScroll = debounce((sidebar, sidebarContainer) => {
  sidebar.style.transform = getSidebarTransfrom(sidebar, sidebarContainer);
}, 100);

/**
 * Initialize
 */
Array.from(document.querySelectorAll('.js-sidebar')).forEach((sidebar) => {
  const sidebarContainer = sidebar.closest('.js-sidebar-container');
  if (!sidebarContainer) {
    return;
  }
  window.addEventListener('scroll', () =>
    handleScroll(sidebar, sidebarContainer)
  );
  // Trigger immediately on load, to account for if we're already scrolled.
  handleScroll(sidebar, sidebarContainer);
});
